import { useEffect } from "react";
import {
    Quote,
    Star,
} from "lucide-react";
import "./CustomerTestimonials.css";
import { useAppDispatch, useAppSelector } from "../../../../../Redux/hooks";
import { fetchEcommerceCustomerTestimonials } from "../../../../../Redux/custmorTestimonials/ecommer-tesimonail/slice";

const CustomerTestimonials = () => {
    const dispatch = useAppDispatch();
    const { customerTestimonials, isLoading } = useAppSelector(
        (state) => state.ecommerceTestimonials
    );

    useEffect(() => {
        dispatch(
            fetchEcommerceCustomerTestimonials({ page: 1, limit: 4 })
        );
    }, [dispatch]);

    if (isLoading || customerTestimonials.length === 0) {
        return null;
    }

    return (
        <section className="customer-testimonials">
            <div className="customer-testimonials-container">
                <div className="customer-testimonials-header">
                    <span className="customer-testimonials-eyebrow">
                        CUSTOMER STORIES
                    </span>

                    <h2>
                        Customer Testimonials
                    </h2>

                    <p>
                        See what our customers say
                        about shopping with Salar.
                    </p>
                </div>

                <div className="customer-testimonials-grid">
                    {customerTestimonials.map(
                        (item, index) => (
                            <article
                                className="customer-testimonial-card"
                                key={item._id}
                            >
                                <div className="customer-testimonial-image">
                                    <img
                                        src={
                                            item.image ||
                                            `/assets/images/testimonials/test-${(index % 8) + 1}.jpg`
                                        }
                                        alt={
                                            item.customerName ||
                                            "Customer"
                                        }
                                    />

                                    <span className="customer-testimonial-quote">
                                        <Quote
                                            size={
                                                16
                                            }
                                            strokeWidth={
                                                1.8
                                            }
                                        />
                                    </span>
                                </div>

                                <div className="customer-testimonial-content">
                                    <div className="customer-testimonial-rating">
                                        {[
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                        ].map(
                                            (
                                                star
                                            ) => (
                                                <Star
                                                    key={
                                                        star
                                                    }
                                                    size={
                                                        13
                                                    }
                                                    strokeWidth={
                                                        1.7
                                                    }
                                                    fill={
                                                        star <=
                                                            (item.rating ??
                                                                5)
                                                            ? "currentColor"
                                                            : "none"
                                                    }
                                                />
                                            )
                                        )}

                                        <span>
                                            {
                                                item.rating ??
                                                5
                                            }
                                            .0
                                        </span>
                                    </div>

                                    <h3>
                                        {
                                            item.title
                                        }
                                    </h3>

                                    <p>
                                        {
                                            item.content
                                        }
                                    </p>

                                    <div className="customer-testimonial-author">
                                        <div>
                                            <strong>
                                                {
                                                    item.customerName ||
                                                    "Customer"
                                                }
                                            </strong>

                                            <span>
                                                Verified
                                                Customer
                                            </span>
                                        </div>

                                        <span className="customer-testimonial-verified">
                                            Verified
                                        </span>
                                    </div>
                                </div>
                            </article>
                        )
                    )}
                </div>
            </div>
        </section>
    );
};

export default CustomerTestimonials;
